import {
  faChevronDown,
  faEye,
  faFileExcel,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { colors } from "../../global";
import FileToSpreadsheetModal from "../Utils/FileToSpreadsheetModal";
import FileToSpreadsheetModalSelect from "../Utils/FileToSpreadsheetModalSelect";

export default function UploadedItemCard({
  file,
  sheetList,
  onUpdateMetadata,
  metadata,
}) {
  const [isPreviewModal, setIsPreviewModal] = useState(false);
  const [isOpenSelectingExcel, setIsOpenSelectingExcel] = useState(false);

  const [activeExcelField, setActiveExcelField] = useState(null);

  const [selectionType, setSelectionType] = useState("all");
  const [typeDropdown, setTypeDropdown] = useState(null);
  const excelSelectionTypeMap = {
    from: "column",
    to: "column",
    range_weight_break_source: "rangeColumn",
    first_data_row: "row",
    header_row: "row", // example for buffer columns
    // default: "all"
  };
  const fields = ["from", "to", "range_weight_break_source", "first_data_row"];
  const fieldsZoneLocation = ["header_row"];
  const formatLabel = (key) => {
    return key.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());
  };
  const closeModal = () => {
    setIsPreviewModal(false);
  };
  function openExcelModalForField(key) {
    const selectionType = excelSelectionTypeMap[key] || "all";
    setActiveExcelField(key);
    setSelectionType(selectionType);
    setIsOpenSelectingExcel(true);
    setTypeDropdown("sheet_information");
  }
  function openExcelZoneLocationModalForField(key) {
    const selectionType = excelSelectionTypeMap[key] || "all";
    setActiveExcelField(key);
    setSelectionType(selectionType);
    setIsOpenSelectingExcel(true);
    setTypeDropdown("zone_location");
  }

  const handleSheetChange = (key, value) => {
    const updated = {
      ...metadata,
      sheet_information: {
        ...metadata.sheet_information,
        [key]: value,
      },
    };
    onUpdateMetadata(updated);
  };
  const handleZoneLocationChange = (key, value) => {
    const updated = {
      ...metadata,
      zone_location: {
        ...metadata.zone_location,
        [key]: value,
      },
    };
    onUpdateMetadata(updated);
  };
  const handleSheetNameChange = (id, name) => {
    const updated = {
      ...metadata,
      sheet_information: {
        ...metadata.sheet_information,
        sheet_name: name,
        sheet_id: id,
      },
    };
    onUpdateMetadata(updated);
  };
  const handleSheetNameZoneLocationChange = (id, name) => {
    const updated = {
      ...metadata,
      zone_location: {
        ...metadata.zone_location,
        sheet_name: name,
        sheet_id: id,
      },
    };
    onUpdateMetadata(updated);
  };
  function closeModalSelectExcel() {
    setIsOpenSelectingExcel(false);
    setActiveExcelField(null);
    setSelectionType("all");
    setTypeDropdown(null);
  }
  function onSelectRange(value) {
    if (typeDropdown === "sheet_information") {
      handleSheetChange(activeExcelField, value);
    } else {
      handleZoneLocationChange(activeExcelField, value);
    }

    closeModalSelectExcel();
  }

  return (
    <>
      {isOpenSelectingExcel && file && (
        <FileToSpreadsheetModalSelect
          file={file}
          closeModal={closeModalSelectExcel}
          metadata={metadata}
          onSubmit={onSelectRange}
          selectionType={selectionType}
          sheet_name={
            typeDropdown === "sheet_information"
              ? metadata.sheet_information.sheet_name
              : metadata.zone_location.sheet_name
          }
        />
      )}
      {isPreviewModal && (
        <FileToSpreadsheetModal file={file} closeModal={closeModal} />
      )}

      <div className="mb-6 border border-gray-200 rounded-xl shadow-sm bg-white">
        {/* Top bar */}
        <div
          className="flex items-center justify-between px-4 py-3 border-b rounded-lg"
          style={{ backgroundColor: colors.accent, color: colors.white }}
        >
          <span className="font-medium text-sm truncate">{file.name}</span>
          <button
            onClick={() => setIsPreviewModal(true)}
            className="bg-white text-sm px-3 py-1 rounded-md hover:opacity-90"
            style={{ color: colors.primary }}
          >
            <FontAwesomeIcon icon={faEye} className="mr-1" />
            Preview
          </button>
        </div>

        <div className="p-6 space-y-8">
          <div>
            <h3 className="text-lg font-semibold text-gray-700 mb-4">
              Sheet Information
            </h3>
            {sheetList.length > 0 && (
              <div className="mb-4 space-y-2">
                <label className="text-sm font-medium text-gray-600">
                  Sheet Name
                </label>
                <div className="relative">
                  <select
                    className="w-full px-4 py-3 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:border-transparent transition-all duration-200 appearance-none bg-white pr-10"
                    style={{
                      "--tw-ring-color": colors.primary + "40",
                      borderColor: metadata.sheet_information.sheet_id
                        ? colors.primary + "40"
                        : undefined,
                    }}
                    value={metadata.sheet_information.sheet_id || ""}
                    onChange={(e) => {
                      const selectedId = e.target.value;
                      const selectedSheet = sheetList.find(
                        (sheet) => sheet.id.toString() === selectedId.toString()
                      );
                      if (selectedSheet) {
                        handleSheetNameChange(
                          selectedId,
                          selectedSheet.information.name
                        );
                      }
                    }}
                  >
                    <option disabled value="" className="text-gray-400">
                      Select Sheet Name
                    </option>
                    {sheetList.map((sheet, index) => (
                      <option
                        key={index}
                        value={sheet.information.id}
                        className="py-2"
                      >
                        {sheet.information.name}
                      </option>
                    ))}
                  </select>
                  <FontAwesomeIcon
                    icon={faChevronDown}
                    size={16}
                    className="absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none"
                    style={{ color: colors.darkGray }}
                  />
                </div>
              </div>
            )}

            {metadata.sheet_information.sheet_id && (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {fields.map((key) => {
                  return (
                    <div key={key} className="space-y-2">
                      <label className="text-sm font-medium text-gray-600">
                        {formatLabel(key)}
                      </label>
                      <div className="flex">
                        <input
                          type="text"
                          placeholder={`Enter ${formatLabel(
                            key
                          ).toLowerCase()}`}
                          className={`flex-1 px-3 py-2 text-sm border border-gray-200 rounded-l-lg focus:outline-none focus:ring-2 focus:border-transparent transition-all duration-200`}
                          style={{
                            "--tw-ring-color": colors.primary + "40",
                            borderColor: metadata.sheet_information[key]
                              ? colors.primary + "40"
                              : undefined,
                          }}
                          value={metadata.sheet_information[key] ?? ""}
                          onChange={(e) =>
                            handleSheetChange(key, e.target.value)
                          }
                        />
                        {openExcelModalForField &&
                          (metadata.file_name.endsWith(".csv") ||
                            metadata?.sheet_information?.sheet_name) && (
                            <button
                              onClick={() => openExcelModalForField(key)}
                              type="button"
                              className="px-3 py-2 border border-l-0 border-gray-200 rounded-r-lg hover:bg-gray-50 transition-colors duration-200"
                              style={{ color: colors.primary }}
                            >
                              <FontAwesomeIcon icon={faFileExcel} size={16} />
                            </button>
                          )}
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>

          <hr className="border-t border-gray-200" />

          {/* ===== Zone Location ===== */}
          <div>
            <h3 className="text-lg font-semibold text-gray-700 mb-4">
              Zone Location
            </h3>
            {sheetList.length > 0 && (
              <div className="mb-4 space-y-2">
                <label className="text-sm font-medium text-gray-600">
                  Sheet Name
                </label>
                <div className="relative">
                  <select
                    className="w-full px-4 py-3 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:border-transparent transition-all duration-200 appearance-none bg-white pr-10"
                    style={{
                      "--tw-ring-color": colors.primary + "40",
                      borderColor: metadata.zone_location.sheet_id
                        ? colors.primary + "40"
                        : undefined,
                    }}
                    value={metadata.zone_location.sheet_id || ""}
                    onChange={(e) => {
                      const selectedId = e.target.value;
                      const selectedSheet = sheetList.find(
                        (sheet) => sheet.id.toString() === selectedId.toString()
                      );
                      if (selectedSheet) {
                        handleSheetNameZoneLocationChange(
                          selectedId,
                          selectedSheet.information.name
                        );
                      }
                    }}
                  >
                    <option disabled value="" className="text-gray-400">
                      Select Sheet Name
                    </option>
                    {sheetList.map((sheet, index) => (
                      <option
                        key={index}
                        value={sheet.information.id}
                        className="py-2"
                      >
                        {sheet.information.name}
                      </option>
                    ))}
                  </select>
                  <FontAwesomeIcon
                    icon={faChevronDown}
                    size={16}
                    className="absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none"
                    style={{ color: colors.darkGray }}
                  />
                </div>
              </div>
            )}
            {metadata.zone_location.sheet_id && (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {fieldsZoneLocation.map((key) => {
                  return (
                    <div key={key} className="space-y-2">
                      <label className="text-sm font-medium text-gray-600">
                        {formatLabel(key)}
                      </label>
                      <div className="flex">
                        <input
                          type="text"
                          placeholder={`Enter ${formatLabel(
                            key
                          ).toLowerCase()}`}
                          className={`flex-1 px-3 py-2 text-sm border border-gray-200 rounded-l-lg focus:outline-none focus:ring-2 focus:border-transparent transition-all duration-200`}
                          style={{
                            "--tw-ring-color": colors.primary + "40",
                            borderColor: metadata.zone_location[key]
                              ? colors.primary + "40"
                              : undefined,
                          }}
                          value={metadata.zone_location[key] ?? ""}
                          onChange={(e) =>
                            handleZoneLocationChange(key, e.target.value)
                          }
                        />
                        {openExcelZoneLocationModalForField &&
                          (metadata.file_name.endsWith(".csv") ||
                            metadata?.zone_location?.sheet_name) && (
                            <button
                              onClick={() =>
                                openExcelZoneLocationModalForField(key)
                              }
                              type="button"
                              className="px-3 py-2 border border-l-0 border-gray-200 rounded-r-lg hover:bg-gray-50 transition-colors duration-200"
                              style={{ color: colors.primary }}
                            >
                              <FontAwesomeIcon icon={faFileExcel} size={16} />
                            </button>
                          )}
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
